var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.8182C21 18.4545 11 25 11 25C11 25 1 18.4545 1 10.8182C1 8.21424 2.05357 5.71695 3.92893 3.87568C5.8043 2.03441 8.34784 1 11 1C13.6522 1 16.1957 2.03441 18.0711 3.87568C19.9464 5.71695 21 8.21424 21 10.8182Z",
    stroke: "#0045F5",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.0909C12.8409 14.0909 14.3333 12.6257 14.3333 10.8182C14.3333 9.0107 12.8409 7.54545 11 7.54545C9.15905 7.54545 7.66667 9.0107 7.66667 10.8182C7.66667 12.6257 9.15905 14.0909 11 14.0909Z",
    stroke: "#0045F5",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ae1f7c6e7483914e9147842552e017c9.svg";
export { ForwardRef as ReactComponent };